import structure from "../../assets/icons/Structure-01.png";
import kitchen from "../../assets/icons/kitchen-01.png";
import painting from "../../assets/icons/painting-01.png";
import plumbing from "../../assets/icons/PLUMBING SANITARY FITTING icon-01.png";
import electrical from "../../assets/icons/electrical-01.png";
import water from "../../assets/icons/water supply-01.png";
import security from "../../assets/icons/security system-01.png";
import generator from "../../assets/icons/GENERATORE-01.png";
import parking from "../../assets/icons/parking-01.png";
import lifts from "../../assets/icons/lift-01.png";

const amenitiesData = [
  {
    title: "Structure & Super Structure",
    description:
      'RCC frame (M20, earthquake resistant). Exterior wall: 6", Interior: 4" Redbricks.',
    icon: structure,
  },
  {
    title: "Plumbing",
    description:
      "Concealed pipelines with ISI fittings. Geyser provision in one toilet.",
    icon: plumbing,
  },
   {
    title: "Painting",
    description:
      "Plastic emulsion in living, dining & bedrooms; OBD elsewhere; textured exterior paint.",
    icon: painting,
  },
  {
    title: "Electrical",
    description:
      "Modular switches with concealed wiring and adequate points for appliances.",
    icon: electrical,
  },
  

  {
    title: "Generator",
    description:
      "Stand-by generator for common amenities & one light/fan point in apartments.",
    icon: generator,
  },
  {
    title: "Water Supply",
    description: "24-hour supply from bore well.",
    icon: water,
  },
  {
    title: "Parking",
    description: "Ample parking for two and four wheelers.",
    icon: parking,
  },
  {
    title: "Lifts",
    description: "Six-person capacity lift with V3F.",
    icon: lifts,
  },
  {
    title: "Kitchen",
    description: "Black granite platform with S.S sink. Dado up to 2' height.",
    icon: kitchen,
  },
    {
    title: "Security System",
    description: "CCTV at main security, lift & staircase lobbies.",
    icon: security,
  },
 
  
];

export default function Amenities() {
  return (
    <div id="specifications">
      <section className="bg-white py-10 xl:py-16 xl:px-[50px] relative overflow-hidden shape">
        <div className="max-w-screen-2xl mx-auto lg:px-6 text-center relative">
          <h2 className="font-crimson text-3xl xl:text-5xl text-[#5e3920] pb-5 mb-5">
            Modern 2 BHK Flats in AURA-Patancheru
          </h2>

          <p className="text-[#000000d9] max-w-3xl mx-auto text-center text-[16px] pb-5 mb-5 xl:text-[18px] px-4 font-inter leading-relaxed">
            Aura combines practical specifications with features designed for
            everyday comfort, safety and convenience. The following
            specifications describe the planned finishes, utilities and common
            facilities provided for the apartments.
          </p>
          <div className="grid xl:grid-cols-5 lg:grid-cols-3 md:grid-cols-2 pt-5 sm:grid-cols-1 grid-cols-1 gap-6 px-5 xl:px-0">
            {amenitiesData.map((item, index) => (
              <div
                key={index}
                className="rounded-[16px] bg-[#fdf6f6] p-5 flex flex-col justify-start items-start
                           shadow-lg hover:shadow-2xl transition-shadow duration-300 ease-in-out
                           h-[200px] sm:h-[220px] md:h-[240px] lg:h-[20px] xl:h-[280px] overflow-hidden"
              >
                <div className="flex flex-col items-start h-full">
                  {/* Icon */}
                  <div className="bg-white w-14 h-14 flex justify-center items-center rounded-xl mb-3">
                    {item.icon && (
                      <img
                        src={item.icon}
                        alt={item.title}
                        className="w-10 h-10 object-contain"
                      />
                    )}
                  </div>
                  {/* Title */}
                  <p className="text-[18px] md:text-[20px] font-inter mb-2 text-[#5e3920] text-left">
                    {item.title}
                  </p>
                  {/* Description */}
                  <p className="text-[#000000d9] text-[14px] md:text-[15px] leading-relaxed font-inter text-left line-clamp-4">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
